let _ = t => t,
  _t,
  _div;
import * as React from 'react';
import styled from 'styled-components';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DebugInfo = styled.code(_t || (_t = _`
  ${0}
`), ({
  theme
}) => `
        display: block;
        padding: ${theme.spacing(2)};
        margin: ${theme.spacing(1.5)} 0 0;
        overflow: auto;
        pre {
            margin: 0;
            padding: 0;
            overflow: initial;
        }
    `);

/**
 * https://reactjs.org/docs/error-boundaries.html
 */
export class ErrorBoundary extends React.PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {};
  }
  static getDerivedStateFromError(error) {
    return {
      error
    };
  }
  render() {
    const {
      errorTitle = 'Sorry, something went wrong.',
      children
    } = this.props;
    const {
      error
    } = this.state;

    // If there's no error, just return what renders via the happy path.
    if (!error) {
      return children;
    }
    const showErrorDetails = process.env.NODE_ENV === 'development';
    return /*#__PURE__*/_jsxs(Alert, {
      severity: "error",
      children: [/*#__PURE__*/_jsx(AlertTitle, {
        children: errorTitle
      }), showErrorDetails ? /*#__PURE__*/_jsxs("p", {
        children: [/*#__PURE__*/_jsxs("b", {
          children: [error.message, ":"]
        }), /*#__PURE__*/_jsx(DebugInfo, {
          children: /*#__PURE__*/_jsx("pre", {
            children: error.stack || JSON.stringify(error, null, 2)
          })
        })]
      }) : _div || (_div = /*#__PURE__*/_jsx("div", {
        children: "Please try again."
      }))]
    });
  }
}
export default ErrorBoundary;